import StoriesWithHashtag from "%/dynamic-component-editor/standard-elements/StoriesWithHashtag.vue";
import HashtagTitle from "%/dynamic-component-editor/standard-pages/stories-with-hashtag-page/HashtagTitle.vue";
import HashtagFollowButton from "%/dynamic-component-editor/standard-pages/stories-with-hashtag-page/HashtagFollowButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyStoriesWithHashtag extends LegacyEntity {
  get elements() {
    return {
      StoriesWithHashtag,
      HashtagTitle,
      HashtagFollowButton,
    };
  }
}
